var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoctorsMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.479 15.042L5.54199 13.292L1.93799 14.708C1.68733 14.8053 1.45466 14.7777 1.23999 14.625C1.02466 14.4723 0.916992 14.264 0.916992 14V3.08301C0.916992 2.90234 0.965326 2.74634 1.06199 2.61501C1.15933 2.48301 1.28466 2.38901 1.43799 2.33301L5.54199 0.958008L10.479 2.68801L14.104 1.27101C14.354 1.18767 14.5797 1.21534 14.781 1.35401C14.9823 1.49267 15.083 1.69401 15.083 1.95801V12.938C15.083 13.118 15.0347 13.2707 14.938 13.396C14.8407 13.5207 14.7153 13.611 14.562 13.667L10.479 15.042ZM9.81199 13.417V3.81201L6.20799 2.56201V12.167L9.81199 13.417ZM11.146 13.417L13.75 12.521V2.83301L11.146 3.81201V13.417ZM2.24999 13.146L4.87499 12.167V2.56201L2.24999 3.45801V13.146Z",
    fill: "#587E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorsMap);
export default __webpack_public_path__ + "static/media/doctors-map.97efaf3051a500d39a5d7e647c825e01.svg";
export { ForwardRef as ReactComponent };